import socketio from "socket.io-client";
import React from "react";
import backendService from "../services.js/backendService";

export const socket = socketio.connect(
  "https://socket-chatdev.onrender.com/"
);
if (backendService.isLoggedIn()) {
  socket.emit("addUser", {
    userId: backendService.getLoggedInUser()._id,
  });
}
export const SocketContext = React.createContext();
